module.exports = __webpack_public_path__ + "img/infant.6f3119f8.svg";